module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-xs-422f3c81aecc28ce203842dafea1f2d7.png";